export default "__VITE_ASSET__C737Kyap__"